var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "b-row",
        [
          _c("login-page", {
            attrs: {
              portal: "broker",
              logo: _vm.$options.filters.getLogo(),
              loading: _vm.loading,
              "loading-status": _vm.loadingStatus,
              "sending-mfa-code": _vm.sendingMfaCode,
              "mfa-code-delivered": _vm.mfaCodeDelivered,
              "is-mfa-required-and-not-enabled": _vm.isMfaRequiredAndNotEnabled,
              "validate-mfa-code": _vm.validateMfaCode,
              "code-destination": _vm.codeDestination,
              "mfa-preferences": _vm.mfaPreferences,
              "mfa-email": _vm.mfaEmail,
            },
            on: {
              enableMfa: _vm.updatePreferredMfaSendCode,
              validateMfaAndSignIn: _vm.validateMfaAndSignIn,
              snoozeMfaSetup: _vm.snoozeMfaSetup,
              reSendCode: _vm.reSendCode,
              submit: _vm.handleLogin,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }